<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="14.0005" y="3" width="4" height="12" rx="1" transform="rotate(90 14.0005 3)" fill="black"/>
<rect x="11.667" y="8.98682" width="4" height="7.33331" rx="1" transform="rotate(90 11.667 8.98682)" fill="black"/>
<path d="M8 1.33331L8 14.6666" stroke="black" stroke-linecap="round"/>
</svg>
